import { SimpleNumberMap } from '@yourcause/common';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { Communication } from './communications.typing';

@RegisterYCState()
export class CommunicationsState extends BaseYcState {
  readonly nonprofitCommunicationsMap: SimpleNumberMap<Communication[][]> = {};
  readonly applicationCommunicationsMap: SimpleNumberMap<Communication[][]> = {};
}
